import React, { ReactElement, useEffect, useState } from 'react';
import { SigmaFrame } from '@host-panel/analytics/sigma/SigmaFrame';
import request from '@host-panel/request';
import { useSelector } from 'react-redux';
import { State } from 'state';
import { PageRoute } from '../../../configs/routeConstants';
import { FetchError } from '@host-panel/analytics/components';

interface SigmaFrameProps {
  page: string;
}

const urlMap = {
  [PageRoute.AnalyticsEmbedEngagement]: 'engagement_url',
  [PageRoute.AnalyticsEmbedRevenue]: 'revenue_url',
  [PageRoute.AnalyticsEmbedModeration]: 'moderation_url'
};

export const SigmaContainer = (props: SigmaFrameProps): ReactElement => {
  const { page } = props;
  const currentUser = useSelector((state: State) => state.currentUser);
  const [src, setSrc] = useState<string>();
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const fetchUrls = async () => {
      try {
        const response = await request('/host-panel/analytics/sigma-urls', {});

        const url = response[urlMap[page]];
        setSrc(url);
      } catch (e) {
        setHasError(true);
      }
    };

    fetchUrls();
  }, [currentUser.id, page]);

  return (
    <>
      {src && <SigmaFrame src={src} />}
      {hasError && <FetchError />}
    </>
  );
};
